module.exports = __webpack_public_path__ + "static/media/group3.2a92e9fb.png";